import type { IContextMutationResult } from '@modules/core/services/query/types';
import type { IDownloadListReportPayload } from '@modules/download-report/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';

import {
  BALANCE_CORRECTIONS_DOWNLOAD_REPORT_MUTATION_KEY,
  BALANCE_CORRECTIONS_DOWNLOAD_REPORT_URL,
  BALANCE_CORRECTIONS_PERMISSIONS,
} from '../constants';

export default function useDownloadBalanceCorrectionsReportMutation(): IContextMutationResult<
  void,
  Error,
  IDownloadListReportPayload
> {
  const { fetchPost } = useRestClient();

  return useContextMutation<void, Error, IDownloadListReportPayload>({
    mutationKey: [BALANCE_CORRECTIONS_DOWNLOAD_REPORT_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<void>(
      BALANCE_CORRECTIONS_DOWNLOAD_REPORT_URL,
      payload,
      { permission: BALANCE_CORRECTIONS_PERMISSIONS.DOWNLOAD_LIST },
    ),
  });
}
